import Api from '@/api/api.js'
import config_api from '@/api/config/_api_config'
const request = (path, payload, token) => Api().post('/consultations/constantes-dossier/' + path, payload, {
    med_access_scoped: true, timeout: 20000, headers: { 'X-Medecin-Constantes': token }
}).then(response => response.data)
const sageFemme = {
    getConstantesAccess() { return config_api().post('/sage-femme/constantes-access', {}, { constantes_dossier_scoped: true, timeout: 20000 }).then(response => response.data) },
    lireConstantes({ access_token, ...payload }) { return this.request('lire', payload, access_token) },
    enregistrerConstantes(payload, token) { return this.request('enregistrer', payload, token) },
    lireSurveillance({ consultation_id, access_token }) { return this.request('surveillance', { consultation_id }, access_token) },
    request(path, payload, token) { return Api().post('/consultations/constantes-sage-femme/' + path, payload, {
        med_access_scoped: true, timeout: 20000, headers: { 'X-Sage-Femme-Constantes': token }
    }).then(response => response.data) }
}
export default {
    sageFemme,
    getConstantesAccess() { return config_api().post('/medecin/constantes-access', {}, { constantes_dossier_scoped: true, timeout: 20000 }).then(response => response.data) },
    lireConstantes({ access_token, ...payload }) { return request('lire', payload, access_token) },
    enregistrerConstantes(payload, token) { return request('enregistrer', payload, token) },
    // Read-only chart: accepts the nurse board or the physician record capability.
    lireSurveillance({ consultation_id, access_token, acces }) {
        const headers = acces === 'infirmier' ? { 'X-Infirmier-Access': access_token } : { 'X-Medecin-Constantes': access_token }
        return Api().post('/consultations/constantes/surveillance/lire', { consultation_id }, { med_access_scoped: true, timeout: 20000, headers }).then(response => response.data)
    }
}
